import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import SearchBar from "../../../component/atoms/input/searchBar";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "../../../component/atoms/layout/table/tr";
import Th from "../../../component/atoms/layout/table/th";
import Checkbox from "../../../component/atoms/input/checkbox";
import TableText from "../../../component/atoms/text/table/tableText";
import Td from "../../../component/atoms/layout/table/td";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import TableCount from "../../../component/molecules/tableCount";
import Pagination from "../../../component/molecules/pagination";
import Empty from "../../../component/molecules/empty";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { errorHandler } from "../../../util/errorHandler";
import { route } from "../../../router/route";
import FreePdfApplyApi from "../../../api/freePdfApply.api";
import moment from "moment";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const UserPDFApplicationList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 행 수 관련 ---------- //
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState("10");
  const [rowsPerPageListBoxOpen, setRowsPerPageListBoxOpen] = useState(false);
  const rowsPerPageList = [
    {
      title: "10명씩",
      value: "10",
    },
    {
      title: "30명씩",
      value: "30",
    },
    {
      title: "50명씩",
      value: "50",
    },
    {
      title: "100명씩",
      value: "100",
    },
  ];

  // ---------- 데이터 관련 ---------- //
  const [freePdfApplyList, setFreePdfApplyList] = useState([]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setSelectedRowsPerPage(
      searchParams.get("perPage") ? searchParams.get("perPage") : "10"
    );

    getMemberList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const getMemberList = async () => {
    try {
      const data = {
        page: Number(page),
        size: searchParams.get("perPage")
          ? Number(searchParams.get("perPage"))
          : pagination.size,
      };

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }
      console.log(data);

      const response = (await FreePdfApplyApi.getList(data)).data.data;
      console.log("response", response);

      setFreePdfApplyList(response.content);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(
          response.totalCount /
            (searchParams.get("perPage")
              ? Number(searchParams.get("perPage"))
              : pagination.size)
        ),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (freePdfApplyList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = freePdfApplyList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }
  }, [checkedListStorage, freePdfApplyList]); /// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>무료 PDF 신청 명단</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount
              fullText={"무료 PDF 신청 명단"}
              count={pagination.totalCount}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.user_pdf_application_list}?page=1&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_pdf_application_list}?page=1&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              <SelectBoxValue
                isMiddle={true}
                selectedValue={selectedRowsPerPage}
                isOpen={rowsPerPageListBoxOpen}
                wrapperHandler={() => {
                  setRowsPerPageListBoxOpen(!rowsPerPageListBoxOpen);
                }}
                itemList={rowsPerPageList}
                selectedValueSetterFunc={(value) => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_pdf_application_list}?page=1&perPage=${value}&keyword=${keyword}`
                  );
                }}
              />
            </div>
          </TableTop>

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="61px" />
              {/* 이름/아이디(이메일) */}
              <col width="674px" />
              {/* 신청일시 */}
              <col width="210px" />
              {/* 보기 */}
              <col width="99px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...freePdfApplyList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          freePdfApplyList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/이메일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    신청일시
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {freePdfApplyList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "76px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TableText>
                          {item?.name || "-"}/{item?.email || "-"}
                        </TableText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>
                        {" "}
                        {item?.createdAt
                          ? moment(item.createdAt).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(
                            `${route.user_pdf_application_list_detail}/${item.id}`
                          );
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {freePdfApplyList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.user_pdf_application_list}
            queryString={`perPage=${selectedRowsPerPage}&keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default UserPDFApplicationList;
